export enum NamedElementBlockRuleRequestTypes {
  GetAllNamedElementBlockRulesRequest = 'namedelementblockrule.getall.request',
  GetAllNamedElementBlockRulesSuccess = 'namedelementblockrule.getall.success',
  GetAllNamedElementBlockRulesFailure = 'namedelementblockrule.getall.failure',
  DeleteNamedElementBlockRuleRequest = 'namedelementblockrule.delete.request',
  DeleteNamedElementBlockRuleSuccess = 'namedelementblockrule.delete.success',
  DeleteNamedElementBlockRuleFailure = 'namedelementblockrule.delete.failure',
  UpdateNamedElementBlockRuleRequest = 'namedelementblockrule.update.request',
  UpdateNamedElementBlockRuleSuccess = 'namedelementblockrule.update.success',
  UpdateNamedElementBlockRuleFailure = 'namedelementblockrule.update.failure',
  UpdateFormPrivacyNamedElementBlockRulesRequest = 'namedelementblockrule.updateformprivacy.request',
  UpdateFormPrivacyNamedElementBlockRulesSuccess = 'namedelementblockrule.updateformprivacy.success',
  UpdateFormPrivacyNamedElementBlockRulesFailure = 'namedelementblockrule.updateformprivacy.failure',
  GetPrivacyFeatureVersionBounds = 'namedelementblockrule.getprivacyfeatureversionbounds.request',
  GetPrivacyFeatureVersionBoundsSuccess = 'namedelementblockrule.getprivacyfeatureversionbounds.success',
  GetPrivacyFeatureVersionBoundsFailure = 'namedelementblockrule.getprivacyfeatureversionbounds.failure',
}
